// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import type { SavedSearch } from 'api/currentUser';
import Icon, { AnimatedCheckmark } from 'components/Icon';
import Box from 'components/Box';
import {
  SecondaryButton,
  PrimaryButton,
  SecondaryButtonLink,
  PrimaryButtonLink
} from 'components/Button';
import { colors } from '../theme';

const { useState, useEffect, useRef } = React;

const StyledIcon = styled(({ fill, ...props }) => (
  <Box pr="6px" {...props}>
    <Icon name="bell" width={14} height={17} fill={fill} />
  </Box>
))`
  svg {
    display: block;
  }
`;

type OwnProps = {
  saved?: boolean,
  primary?: boolean,
  onClick?: Function
};

type Props = OwnProps & {
  savedSearches: Array<SavedSearch>
};

const EmailAlertButton = ({
  saved,
  primary,
  onClick,
  savedSearches,
  // eslint-disable-next-line react/prop-types
  dispatch,
  ...props
}: Props) => {
  const [
    state: {
      message: string,
      icon: React.Node,
      onClick: ?Function,
      href: ?string
    },
    setState
  ] = useState({
    message: getText('Create Email Alert'),
    icon: <StyledIcon />,
    onClick,
    href: null
  });
  const initiallySaved = useRef(saved);

  useEffect(
    () => {
      if (saved && savedSearches) {
        const savedState = {
          message: `${getText('My Alerts')} (${savedSearches.length})`,
          icon: <StyledIcon />,
          onClick: null,
          href: '/dashboard/email-alerts'
        };
        if (initiallySaved.current) {
          setState(savedState);
        } else {
          setState({
            ...savedState,
            message: getText('Alert Saved!'),
            icon: (
              <AnimatedCheckmark
                mr="8px"
                stroke={primary ? 'white' : colors.turtleGreen}
              />
            )
          });
          window.setTimeout(() => {
            setState(savedState);
          }, 3000);
        }
      } else {
        setState({
          message: getText('Create Email Alert'),
          icon: <StyledIcon />,
          onClick,
          href: null
        });
      }
    },
    [onClick, primary, saved, savedSearches]
  );

  const Button = primary
    ? saved
      ? PrimaryButtonLink
      : PrimaryButton
    : saved
    ? SecondaryButtonLink
    : SecondaryButton;

  return (
    <Button onClick={state.onClick} href={state.href} {...props}>
      <Box display="flex" alignItems="center">
        {state.icon}
        {state.message}
      </Box>
    </Button>
  );
};

const mapStateToProps = ({ currentUser: { savedSearches } }) => ({
  savedSearches
});

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps)(
  EmailAlertButton
);
